import { render } from "./ManageBusinessUnits.vue?vue&type=template&id=83b286c8&ts=true"
import script from "./ManageBusinessUnits.vue?vue&type=script&lang=ts"
export * from "./ManageBusinessUnits.vue?vue&type=script&lang=ts"

import exportComponent from "/home/appstore/appstore/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__